/**
 * Session group status — wire contract from oscerai/ml-scribe (APP-7406).
 * Network-sourced; do not persist outside React Query.
 *
 * TODO: Remove this manual type once the OpenAPI schema is regenerated via
 * `pnpm run schema:dev` and exposes `session_group_status` on the session
 * list + detail views.
 */

export type SessionGroupStatus =
  | 'no_action'
  | 'pending_patient_link'
  | 'pending_user_review'
  | 'user_discarded'
  | 'grouped';

/**
 * Raw wire value as received from the backend — may be any string (unknown,
 * future, or mis-cased). Use this for un-normalized fields (e.g. the session
 * list/simple payloads) and read it through {@link toSessionGroupStatus}. The
 * `(string & {})` arm keeps editor autocomplete for the known values without
 * asserting the value is actually one of them.
 */
export type RawSessionGroupStatus = SessionGroupStatus | (string & {});

/** All known wire values, in backend order. */
export const SESSION_GROUP_STATUSES: readonly SessionGroupStatus[] = [
  'no_action',
  'pending_patient_link',
  'pending_user_review',
  'user_discarded',
  'grouped',
];

/** Graceful default for a null / empty / unrecognised value. */
export const DEFAULT_SESSION_GROUP_STATUS: SessionGroupStatus = 'no_action';

/**
 * Coerce a raw wire value into a known {@link SessionGroupStatus}. Matching is
 * case-insensitive; anything unrecognised — null, undefined, empty, or a future
 * backend value — degrades to `no_action` so the UI never breaks on an unknown
 * status.
 */
export function toSessionGroupStatus(
  value: string | null | undefined
): SessionGroupStatus {
  const normalized = value?.trim().toLowerCase();
  return (
    SESSION_GROUP_STATUSES.find((status) => status === normalized) ??
    DEFAULT_SESSION_GROUP_STATUS
  );
}
